import { drawerAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(drawerAnatomy.keys)

const baseStyle = definePartsStyle({
  dialog: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  header: {
    color: 'presets.turquoise.100',
    fontSize: '16px',
    fontWeight: '500',
  },
})

export const drawerTheme = defineMultiStyleConfig({ baseStyle })
